import React from 'react'
import { Link } from 'react-router-dom'
import {
  COLUMN_TYPES,
  COLUMN_SORT_SETTING,
  DATA_TYPES,
  SEARCH_TYPES,
  Icon,
  reducers,
  coreConstants,
} from '@adc/ui-morpheus'
import { USERS } from '../../constants/tableTypes'
import { userStatuses as statusOptions } from '../../constants/optionLists'

const SEARCH_ANALYZER = 'searchAnalyzer'
const SORT_ANALYZER = 'sortAnalyzer'
const getDefaultProps = width => ({
  width,
  isResizable: true,
  isReorderable: true,
  isVisible: false,
})

const { yesNo: yesNoList } = coreConstants.optionLists

export const tableConfig = {
  config: {
    entityKey: USERS,
    primaryKeyField: 'user_id',
    allowExportCSV: true,
  },
  fieldDefinitions: [
    {
      name: 'Selected',
      apiRef: 'selected', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.CHECKBOX,
        colProps: { width: 40, fixed: true },
      },
    },
    {
      name: 'Last Name',
      apiRef: 'person.last_name',
      sortAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(200),
          isVisible: true,
          sort: COLUMN_SORT_SETTING.SORTED,
          sortAscending: true,
          searchable: true,
        },
      },
    },
    {
      name: 'First Name',
      apiRef: 'person.first_name',
      sortAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(200),
          isVisible: true,
          sort: COLUMN_SORT_SETTING.NOT_SORTED,
          searchable: true,
        },
      },
    },
    {
      name: 'Email',
      apiRef: 'security.email',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(300),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Party ID',
      apiRef: 'party_id',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        dataType: DATA_TYPES.NUMBER,
        colProps: {
          ...getDefaultProps(100),
          isVisible: false,
          sort: COLUMN_SORT_SETTING.NOT_SORTABLE,
          searchable: true,
        },
      },
    },
    {
      name: 'Legal First Name',
      apiRef: 'person.person_legal_details.legal_first_name',
      sortAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(200),
          isVisible: true,
          sort: COLUMN_SORT_SETTING.NOT_SORTED,
          searchable: true,
        },
      },
    },
    {
      name: 'Legal Last Name',
      apiRef: 'person.person_legal_details.legal_last_name',
      sortAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(200),
          isVisible: true,
          sort: COLUMN_SORT_SETTING.NOT_SORTED,
          searchable: true,
        },
      },
    },
    {
      name: 'Legal DOB',
      apiRef: 'person.person_legal_details.date_of_birth',
      sortAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.DATE, // Date Pattern
        partialMatch: true,
        colProps: {
          ...getDefaultProps(150),
          isVisible: true,
          sort: COLUMN_SORT_SETTING.NOT_SORTED,
          searchable: false,
        },
      },
    },
    {
      name: 'Access Roles',
      apiRef: 'security.roles',
      searchType: SEARCH_TYPES.SUGGEST_ASYNC_ONE_TIME,
      searchAnalyzer: '.lowercase',
      columnDefinition: {
        type: COLUMN_TYPES.LABEL,
        colProps: {
          ...getDefaultProps(200),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Party Roles',
      apiRef: 'roles.role_name',
      searchType: SEARCH_TYPES.SUGGEST_ASYNC_ONE_TIME,
      searchAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.LABEL,
        colProps: {
          ...getDefaultProps(200),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Phones',
      apiRef: 'phones.number',
      searchType: SEARCH_TYPES.TEXT,
      searchAnalyzer: '',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: false,
        colProps: {
          ...getDefaultProps(200),
          isVisible: true,
          sort: COLUMN_SORT_SETTING.NOT_SORTABLE,
          searchable: true,
        },
      },
    },
    {
      name: 'Status',
      apiRef: 'security.status',
      searchType: SEARCH_TYPES.SUGGEST_SYNC,
      searchAnalyzer: '.lowercase',
      options: statusOptions,
      formatOptions: {
        titleCase: true,
      },
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: {
          ...getDefaultProps(100),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'ID Verified',
      apiRef: 'person.person_legal_details.id_verified',
      searchType: SEARCH_TYPES.SUGGEST_SYNC,
      options: yesNoList,
      columnDefinition: {
        dataType: DATA_TYPES.BOOLEAN,
        type: COLUMN_TYPES.BOOL,
        colProps: {
          ...getDefaultProps(100),
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'User ID',
      apiRef: 'user_id',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        dataType: DATA_TYPES.NUMBER,
        colProps: {
          ...getDefaultProps(100),
          isVisible: false,
          sort: COLUMN_SORT_SETTING.NOT_SORTABLE,
          searchable: true,
        },
      },
    },
    {
      name: 'Edit',
      apiRef: '__actions__', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: ['Link'],
        colProps: { width: 50, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
  sortBy: [
    {
      field: 'template_name.lowercase',
      order: 'asc',
    },
  ],
}

const linkColumnAction =
  () => (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Link
        style={{ margin: -8, padding: 8 }}
        key={actionIndex}
        to={`/user-management/${primaryId}/edit`}
        data-elm-id={`action_edit_${rowIndex}`}
      >
        <Icon
          size='large'
          style={{ marginTop: -3 }}
          name='write square'
          color='info'
          onClick={() => onRowAction(rowIndex)}
        />
      </Link>
    )

/**
 *
 * @param {*} fieldDefinitions
 * THIS SELECTOR IS TO MAINTAIN BACKWARDS COMPATIBILITY WITH EVERYTHING IN TOOLKIT
 * It will change/ be removed when everything there changes. This is so we can refactor slowly
 */
export const columnSelector = state =>
  state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(linkColumnAction)
      if (col.searchType) column.searchType = col.searchType
      if (col.options) column.options = col.options
      if (col.formatOptions) column.formatOptions = col.formatOptions
      if (SEARCH_ANALYZER in col) column.searchAnalyzer = col.searchAnalyzer
      if (SORT_ANALYZER in col) column.sortAnalyzer = col.sortAnalyzer
      return column
    })

export const getFilterClauses = state => state.filterClauses

export default reducers.dataTable.dataTable(USERS, tableConfig)
